import { ApplicationError } from '~/domain/ApplicationError'

export const errors: Record<ApplicationError['code'], ApplicationError> = {
  // thirdweb Marketplace contract
  '!BAL20': {
    code: '!BAL20',
    message: 'Insufficient token balance to purchase listing, or pending transfer approval',
  },
  '!BALNFT': {
    code: '!BALNFT',
    message: 'Insufficient NFT balance to list them, or pending transfer approval',
  },
  '!ADMIN': {
    code: '!ADMIN',
    message: 'You must have admin role to perform this action',
  },
  'Reason: Marketplace: insufficient currency balance': {
    code: 'INSUFFICIENT_BALANCE',
    message: 'Insufficient currency balance.',
  },
  'Reason: ERC20: transfer amount exceeds balance': {
    code: 'INSUFFICIENT_ERC20_BALANCE',
    message: 'Insufficient currency balance.',
  },
  // Wallet
  'ACTION_REJECTED': {
    code: 'ACTION_REJECTED',
    message: 'You rejected the transaction',
  },
  'Reason: user rejected transaction': {
    code: 'ACTION_REJECTED',
    message: 'You rejected the transaction',
  },
  'Reason: insufficient funds for intrinsic transaction cost': {
    code: 'INSUFFICIENT_FUNDS',
    message: 'Insufficient funds. Please add {{currency}} to your wallet.',
  },
  // Factory
  'Reason: only whitelisted nft collections can be fragmented': {
    code: 'ONLY_WHITELISTED_COLLECTIONS',
    message: 'Only whitelisted nft collections can be fragmented.',
  },
  // Others
  'UNKNOWN_TX_ERROR': {
    code: 'UNKNOWN_TX_ERROR',
    message: 'Transaction error, please report if it persists',
  },
}
